import { render } from "./MultiSelectGroupDropdown.vue?vue&type=template&id=2158a5d2&scoped=true"
import script from "./MultiSelectGroupDropdown.vue?vue&type=script&lang=js"
export * from "./MultiSelectGroupDropdown.vue?vue&type=script&lang=js"

import "./MultiSelectGroupDropdown.vue?vue&type=style&index=0&id=2158a5d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2158a5d2"]])

export default __exports__